import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Divider, Box, Stack, Button, IconButton, useMediaQuery, Slide } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import Lottie from 'lottie-react';
import { Success as SuccessAnimation, Error as ErrorAnimation } from 'src/_assets/animations';

// Icons
import CloseIcon from '@mui/icons-material/Close';
import PaymentIcon from '@mui/icons-material/Payment';

export default function PaymentStatusDialog({
    open,
    onClose,
    payment_status,
    message,
}) {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const location = useLocation();
    const fullscreen = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const handleClose = () => {
        const { pathname, search } = location;
        const params = new URLSearchParams(search);
        let changed = false;
        ['payment_status', 'message', 'target'].forEach((key) => {
            if (params.has(key)) {
                params.delete(key);
                changed = true;
            }
        });
        const newSearch = params.toString();
        if (changed) {
            navigate(`${pathname}${newSearch ? `?${newSearch}` : ''}`, { replace: true });
        }
        onClose();
    }

    return (
        <Dialog
            keepMounted
            open={open}
            onClose={(e) => e.preventDefault()}
            maxWidth="md"
            fullWidth
            fullScreen={fullscreen}
            TransitionComponent={Slide}
            TransitionProps={{ direction: 'up' }}
            PaperProps={{
                sx: {
                    borderRadius: fullscreen ? 0 : 3,
                    overflow: 'hidden',
                }
            }}
        >
            {/* Header */}
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Stack direction="row" alignItems="center" spacing={1.5}>
                    <PaymentIcon />
                    <Typography variant="h6" fontWeight={600}>
                        {t('Payment Status')}
                    </Typography>
                </Stack>
                <IconButton
                    onClick={handleClose}
                    sx={{ color: 'inherit' }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Divider />

            <DialogContent sx={{ p: 0 }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        py: 6,
                        px: 3,
                        minHeight: 300,
                    }}
                >
                    <Lottie
                        animationData={payment_status === 'success' ? SuccessAnimation : ErrorAnimation}
                        loop={false}
                        style={{ width: 180, height: 180 }}
                    />
                    <Typography
                        variant="h5"
                        fontWeight={700}
                        sx={{
                            mt: 2,
                            color: payment_status === 'success' ? 'success.main' : 'error.main',
                            textAlign: 'center',
                        }}
                    >
                        {payment_status === 'success'
                            ? t('Payment Successful')
                            : t('Payment Failed')}
                    </Typography>
                    <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ mt: 1.5, textAlign: 'center', maxWidth: 320 }}
                    >
                        {payment_status === 'success'
                            ? t('Your payment has been successfully.')
                            : message || t('There was an issue processing your payment. Please try again.')}
                    </Typography>
                    {/* {payment_status === 'success' && (
                                       <Paper
                                           elevation={0}
                                           sx={{
                                               mt: 3,
                                               px: 4,
                                               py: 2,
                                               bgcolor: (theme) => alpha(theme.palette.success.main, 0.08),
                                               borderRadius: 2,
                                               border: '1px solid',
                                               borderColor: (theme) => alpha(theme.palette.success.main, 0.2),
                                           }}
                                       >
                                           <Typography variant="h6" fontWeight={600} color="success.main" textAlign="center">
                                               {totalAmount?.toFixed(2)} {t('Currency')}
                                           </Typography>
                                           <Typography variant="caption" color="text.secondary" textAlign="center" display="block">
                                               {t('Added to your balance')}
                                           </Typography>
                                       </Paper>
                                   )} */}
                </Box>
            </DialogContent>
            <Divider />

            <DialogActions sx={{ p: 2.5 }}>
                <Box mr="auto" />
                <Button
                    variant="contained"
                    onClick={handleClose}
                    sx={{ textTransform: 'none' }}
                >
                    {t('Close')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
